{
	"title": "Gérer les déclarations",
	"createDeclaration": "Créer une déclaration"
}
